import { createAction } from '../../../core/helpers'

import { FETCH_UNKNOWN_WORDS } from '../action-types'

export const cleanupUnknownWords = createAction(FETCH_UNKNOWN_WORDS.CLEANUP)
